module.exports = __webpack_public_path__ + "img/logo-labrador-straits-community-714x200px.5f7c9fb2.png";